export const MARKING_PORTAL_PATH = '/marking-portal';

/** @deprecated Totem links previously used `/checkin`; kept for redirects and old bookmarks. */
export const LEGACY_MARKING_PORTAL_CHECKIN_PATH = '/checkin';

const MARKING_PORTAL_PATH_REGEXP = new RegExp(`^${MARKING_PORTAL_PATH}/?$`);
const LEGACY_CHECKIN_PATH_REGEXP = new RegExp(`^${LEGACY_MARKING_PORTAL_CHECKIN_PATH}/?$`);

export const getMarkingPortalToken = (search: string): string | null => {
  const token = new URLSearchParams(search).get('token');
  return token?.trim() || null;
};

export const buildMarkingPortalUrl = (token: string): string =>
  `${MARKING_PORTAL_PATH}?token=${encodeURIComponent(token)}`;

export const isMarkingPortalPathname = (pathname: string): boolean =>
  MARKING_PORTAL_PATH_REGEXP.test(pathname);

export const isLegacyCheckInPathname = (pathname: string): boolean =>
  LEGACY_CHECKIN_PATH_REGEXP.test(pathname);

export const isMarkingPortalPublicAuthPathname = (pathname: string): boolean =>
  isMarkingPortalPathname(pathname) || isLegacyCheckInPathname(pathname);

export const isPublicPortalEntryPath = (
  pathname: string,
  search: string,
): boolean => isMarkingPortalPublicAuthPathname(pathname) && Boolean(getMarkingPortalToken(search));

export const buildLegacyCheckInRedirectLocation = (
  search: string,
): { pathname: string; search: string } => ({
  pathname: MARKING_PORTAL_PATH,
  search,
});
